var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSponsor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "12 32 478 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.5 227H136.194a9.996 9.996 0 01-5.797-1.852l-5.578-3.968a5 5 0 01-.637-7.61l17.318-17.318",
    stroke: "url(#sponsor_svg__paint0_linear)",
    strokeWidth: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228 289.5l17.87-40.534a9.999 9.999 0 019.15-5.966h15.092a5.001 5.001 0 004.331-2.501l6.057-10.498",
    stroke: "url(#sponsor_svg__paint1_linear)",
    strokeWidth: 3.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.314 75.179l-12.882 20.585a10 10 0 01-10.077 4.566l-14.78-2.395a5 5 0 00-4.675 1.776l-7.658 9.394",
    stroke: "url(#sponsor_svg__paint2_linear)",
    strokeWidth: 3.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.5 80H196.194a10 10 0 00-5.797 1.852l-5.578 3.968a5 5 0 00-.637 7.61l17.318 17.318",
    stroke: "url(#sponsor_svg__paint3_linear)",
    strokeWidth: 3.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 152h118.306a9.996 9.996 0 005.797-1.852l5.578-3.968a5 5 0 00.637-7.61L113 121.252",
    stroke: "url(#sponsor_svg__paint4_linear)",
    strokeWidth: 3.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 279l16.568-17.582c4.182-4.438 3.452-11.554-1.543-15.051l-30.76-21.532c-5.094-3.566-5.734-10.866-1.337-15.263l40.108-40.108a5 5 0 013.535-1.464H149",
    stroke: "url(#sponsor_svg__paint5_linear)",
    strokeWidth: 3.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121 2l41.901 43.577c4.255 4.425 3.556 11.604-1.473 15.124l-30.663 21.464c-5.094 3.566-5.734 10.866-1.337 15.263l40.108 40.108a5 5 0 003.535 1.464H190",
    stroke: "url(#sponsor_svg__paint6_linear)",
    strokeWidth: 3.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M388 268l-41.901-43.577c-4.255-4.425-3.556-11.603 1.473-15.124l30.663-21.464c5.094-3.566 5.734-10.866 1.337-15.263l-40.108-40.108a5 5 0 00-3.535-1.464H319",
    stroke: "url(#sponsor_svg__paint7_linear)",
    strokeWidth: 3.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M478 183h-51.567a10 10 0 01-7.41-3.285l-51.679-57.025a19.998 19.998 0 00-8.027-5.381l-19.413-7.01c-6.074-2.194-8.507-9.484-4.968-14.886L347 77",
    stroke: "url(#sponsor_svg__paint8_linear)",
    strokeWidth: 3.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(1 0 0 -1 144.5 193.5)",
    fill: "#86CD74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 113.5,
    r: 4.5,
    fill: "#86CD74"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 118.5,
    r: 4.5,
    transform: "rotate(-180 110 118.5)",
    fill: "#86CD74"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(1 0 0 -1 144.5 168.5)",
    fill: "#86CD74"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 138.5,
    r: 4.5,
    fill: "#86CD74"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.5,
    cy: 131.5,
    r: 4.5,
    transform: "rotate(-180 323.5 131.5)",
    fill: "#86CD74"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 229.5,
    r: 4.5,
    transform: "rotate(-180 280.5 229.5)",
    fill: "#86CD74"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.162,
    cy: 109.599,
    r: 4.5,
    transform: "rotate(9.205 260.162 109.599)",
    fill: "#86CD74"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.5,
    cy: 79.5,
    r: 4.5,
    transform: "rotate(-180 346.5 79.5)",
    fill: "#86CD74"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint0_linear",
    x1: 133,
    y1: 227,
    x2: 217,
    y2: 227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint1_linear",
    x1: 278.5,
    y1: 230,
    x2: 235.5,
    y2: 285.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint2_linear",
    x1: 262.216,
    y1: 109.426,
    x2: 297.762,
    y2: 80.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint3_linear",
    x1: 200,
    y1: 111,
    x2: 268.5,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint4_linear",
    x1: 114.5,
    y1: 121,
    x2: -0.5,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint5_linear",
    x1: 114.5,
    y1: 168,
    x2: 115,
    y2: 291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint6_linear",
    x1: 155.5,
    y1: 139,
    x2: 156,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint7_linear",
    x1: 353.5,
    y1: 131,
    x2: 375,
    y2: 257.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sponsor_svg__paint8_linear",
    x1: 341,
    y1: 76,
    x2: 449,
    y2: 183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312F3F",
    stopOpacity: 0
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgSponsor as ReactComponent };